import type { HealthState } from '@central/api';
import { healthLabels, toneForHealth } from './health';
import { StatusChip } from './StatusChip';

/** A health state as a status chip; `labels` words the states for its audience. */
export function HealthChip({
  state,
  labels = healthLabels,
}: {
  state: HealthState;
  labels?: Record<HealthState, string>;
}) {
  return <StatusChip tone={toneForHealth(state)}>{labels[state]}</StatusChip>;
}
